import styled from '@emotion/styled';

export const Container = styled.div`
    padding: 0 20px;
    margin: 0 auto;
    width: 100%;
    max-width: 576px;
    text-align: center;
`;
